export default __webpack_public_path__ + "static/image--blog-2-5e5e9d0f7fdacb2a3afa69b9983b0165.jpg";